export const forums = {
  forumsSearchInputPlaceholder: 'Rechercher',
  forumsFollowDiscussionButtonTitle: 'Suivre',
  forumsFollowingDiscussButtonTitle: 'Suivi',
  forumDiscussionInfoNoReplyText: 'Pas encore de réponses',
  forumsDiscussionDetailsStartButtonTitle: 'Démarrer la discussion',
  forumDetailsCreatedByText: 'par',
  forumsDiscussionDetailsUsersCurtainCopyOptionTitle: 'Copier le lien',
  forumsDiscussionDetailsUsersCurtainFlagOptionTitle: 'Signaler le contenu',
  forumsReportedCurtainContent: 'Contenu signalé',
  forumsDiscussionDetailsUserCurtainCopiedAlertText: 'Lien copié !',
  forumsDiscussionDetailsOwnersCurtainPinOptionTitle: 'Épingler la discussion',
  forumsDiscussionDetailsOwnersCurtainUnpinOptionTitle: 'Détacher la discussion',
  forumsDiscussionDetailsOwnersCurtainEditOptionTitle: 'Modifier la discussion',
  forumsDiscussionDetailsOwnersCurtainDeleteOptionTitle: 'Supprimer la discussion',
  forumsDiscussionDetailspPopupDeleteTitle: 'Supprimer',
  forumsDiscussionDetailspPopupDeleteText: 'Supprimer cette discussion ?',
  forumsDiscussionDetailspPopupCancelButtonTitle: 'Annuler',
  forumsDiscussionDetailspPopupConfirmButtonTitle: 'Confirmer',
  forumsDiscussionDetailsDeleledAlertText: 'Discussion supprimée !',
  forumsNewDiscussionTitle: 'Nouvelle discussion',
  forumsNewDiscussionTitlePlaceholder: 'Titre...',
  forumsNewDiscussionBodyPlaceholderText: 'Saisissez votre texte ici...',
  forumsNewDiscussionPublishButtonTitle: 'Publier',
  forumsNewDiscussionLocationCurtainTitle: 'Emplacement',
  forumsNewDiscussionLocationCurtainInputPlaceholder: "Nom de l'emplacement",
  forumsNewDiscussionEditLocationCurtainText: "Modifier l'emplacement",
  forumsNewDiscussionDeleteLocationCurtainText: "Supprimer l'emplacement",
  forumsNewDiscussionCreatePollTitle: 'Créer un sondage',
  forumsNewDiscussionTitleInputPlaceholder: 'Titre',
  forumsNewDiscussionOptionInputPlaceholder: 'Option',
  forumsNewDiscussionAddButtonTitle: 'Ajouter une option',
  forumsNewDiscussionCreateButtonTitle: 'Créer',
  forumsNewDiscussionPollTitleBlankAlertText: 'Le titre ne peut pas être vide !',
  forumsNewDiscussionPollOptionBlankAlertText: "L'option ne peut pas être vide !",
  forumsNewDiscussionPollLongTitleAlertText: 'Le titre doit contenir au maximum 140 caractères',
  forumsNewDiscussionPollLongOptionAlertText: "L'option doit contenir au maximum 50 caractères",
  forumsNewDiscussionEditPollIconText: 'Modifier le sondage',
  forumsNewDiscussionRemovePollIconText: 'Supprimer le sondage',
  forumsDiscardDraftPopupTitle: 'Brouillon',
  forumsDiscardDraftPopupText: 'Supprimer ce brouillon ?',
  forumsDiscardDraftPopupCancelButtonTitle: 'Annuler',
  forumsDiscardDraftPopupConfirmButtonTitle: 'Confirmer',
  forumsDiscussionDetailsPostBodyReplyIconTitle: 'Répondre',
  forumsDiscussionDetailsNoCommentsText: "Il n'y a pas encore de commentaires\nVous pouvez être le premier",
  forumsDiscussionDetailsReplyInputPlaceholder: 'Répondre',
  forumsDiscussionDetailsPostShareCurtainOptionTitle: 'Copier le lien',
  forumsDiscussionDetailsPostShareCopiedAlertText: 'Lien copié !',
  forumsDiscussionDetailsPostUsersCurtainFlagOptionTitle: 'Signaler le contenu',
  forumsDiscussionDetailsPostCurtainReportedText: 'Contenu signalé',
  forumsDiscussionDetailsCommentReplyIconTitle: 'Répondre',
  forumsEditDiscussionTitle: 'Modifier la discussion',
  forumsEditDiscussionSaveButtonTitle: 'Enregistrer',
  forumsEditedDiscussionSavedAlertText: 'Discussion enregistrée !',
  forumsDiscussionDetailsOwnersCommentCurtainEditOptionTitle: 'Modifier la réponse',
  forumsDiscussionDetailsOwnersCommentCurtainDeleteOptionTitle: 'Supprimer la réponse',
  forumsDiscussionDetailsEditedCommSavedAlertText: 'Commentaire enregistré !',
  forumsDiscussionDetailsEditedCommDeletedAlertText: 'Commentaire supprimé !',
  forumsAlertSomethinWrong: "Quelque chose s'est mal passé !",
  forumsMaxMbSize: "Vous pouvez télécharger jusqu'à {size} Mo à la fois",
  forumsMaxAttachments: 'Vous avez dépassé le nombre maximal de pièces jointes. Le nombre maximal de pièces jointes est {max}',
  forumsDiscussionDetailsDeleteCommentPopupTitle: 'Supprimer',
  forumsDiscussionDetailsDeleteCommentPopupText: 'Supprimer ce commentaire ?',
  forumsDiscussionDetailsDeleteCommentPopupCancelButtonTitle: 'Annuler',
  forumsDiscussionDetailsDeleteCommentPopupConfirmlButtonTitle: 'Confirmer',
  forumsDiscussionDetailsUsersCommentCurtainFlagOptionTitle: 'Signaler le contenu',
  forumsDiscussionDetailsCommentReportedCurtainText: 'Contenu signalé',
  forumDiscussionInfoLastReplyText: 'Dernière réponse',
  forumsDiscussionAt: 'à',
  forumsDiscussionDetailsFlagCurtainTitle: 'Signaler',
  forumsDiscussionDetailsFlaggedReportedCurtainContent: 'Contenu signalé',
  forumsPollInfoVotesText: 'votes',
  forumsPollInfoEditVoteText: 'Modifier le vote',
  forumsPollFinishPollText: 'Terminer le sondage',
  forumsPollFinishedPollText: 'Terminé',
  forumsPollInProgresslText: 'En cours',
  forumsPollCurtainTitle: 'Terminer le sondage',
  forumsPollCurtainText: 'Les utilisateurs ne pourront plus voter une fois que le sondage sera terminé.',
  forumsFinishPollCurtainCancelButtonTitle: 'Annuler',
  forumsFinishPollCurtainConfirmlButtonTitle: 'Confirmer',
  forumsPollInfoPollVotesCurtainTitle: 'Votes du sondage'
}
